// extracted by mini-css-extract-plugin
export default {"page":"T4KlGgn7","title":"HPGCC_1w","title-container":"Hfn1wQj8","secondaryText":"Xe6tJ4gz","help-icon":"DM8Zf_sI"};